module.exports = __webpack_public_path__ + "img/header-weddingRingsMillgrif.7b3ffa4.webp";